/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { cx } from '../utils'

export interface BadgeProps {
  children: React.ReactNode
  variant?: 'ghost' | 'primary' | 'info' | 'success' | 'warning' | 'error' | 'outline'
  size?: 'xs' | 'sm'
  className?: string
  title?: string
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'ghost', size = 'sm', className, title }) => (
  <span className={cx('badge', `badge-${variant}`, `badge-${size}`, className)} title={title}>
    {children}
  </span>
)

export default Badge
